import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const CreateOffboardingFormMutation = gql`
  mutation CreateOffboardingForm(
    $engagementId: ID!
    $proposedDate: ISO8601Date!
    $reason: String!
    $communicatedWithEmployee: Boolean!
    $intendedDaysOff: Float
    $ptoInaccurateNote: String
    $notes: String
    $primaryCategoryId: ID!
    $secondaryCategoryId: ID
    $earlyOffboardingRequested: Boolean
    $earlyOffboardingReason: String
    $teamMemberOwedCommission: Boolean
    $commissionDetails: String
  ) {
    createOffboardingForm(
      input: {
        engagementId: $engagementId
        proposedDate: $proposedDate
        reason: $reason
        communicatedWithEmployee: $communicatedWithEmployee
        intendedDaysOff: $intendedDaysOff
        ptoInaccurateNote: $ptoInaccurateNote
        notes: $notes
        primaryCategoryId: $primaryCategoryId
        secondaryCategoryId: $secondaryCategoryId
        earlyOffboardingRequested: $earlyOffboardingRequested
        earlyOffboardingReason: $earlyOffboardingReason
        teamMemberOwedCommission: $teamMemberOwedCommission
        commissionDetails: $commissionDetails
      }
    ) {
      errors
    }
  }
`

export const useCreateOffboardingForm = (options?: MutationHookOptions) => {
  return useMutation(CreateOffboardingFormMutation, options)
}
